export default __webpack_public_path__ + "static/media/topplprofile.dac7969e.png";